<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :pathResource="pathResource">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data dal:</label>
                        <date-picker v-model="filtroPriLista.dataDal" format="DD-MM-YYYY" value-type="timestamp"
                            placeholder="Seleziona data iniziale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data al:</label>
                        <date-picker v-model="filtroPriLista.dataAl" format="DD-MM-YYYY" value-type="timestamp"
                            placeholder="Seleziona data finale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Stato:</label>
                        <b-form-select v-model="filtroPriLista.stato" type="search" id="tipoScale"
                            placeholder="Inserire tipo scala" :options="statiPriOptions">
                            <template #first>
                                <b-form-select-option :value="null">- TUTTI - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
                        class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{
                            this.$i18n.t("patients.lblResetFilter")
                            }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <ProgettoRiabilitativoIndividualeListComponent ref="cmpProgettoRiabilitativoIndividualeListComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";

import DatePicker from "vue2-datepicker";
import ProgettoRiabilitativoIndividualeListComponent from "../components/ProgettoRiabilitativoIndividualeListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        ProgettoRiabilitativoIndividualeListComponent,
        DatePicker,
    },
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            filtro: {},
            btnNewVisible: true,
            pathResource: "/progettoriabilitativoindividuale",
            pathResourceAccettazione: "/accettazioni",
            linkback: "/rsagestioneospiti",
            listKey: 0,
            filtroPriLista: { stato: null, dataDal: null, dataAl: null },
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
            statiPriOptions: [],
        };
    },
    mounted() {
        this.idAccettazione = this.$route.query.idAccettazione;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroPriLista"]) {
            this.filtroPriLista = JSON.parse(sessionStorage["filtroPriLista"]);
        }
        this.filtroPriLista.idAccettazione = this.$route.query.idAccettazione;
        // me.loadTipologieSchedeValutazione();
        this.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpProgettoRiabilitativoIndividualeListComponent.init(response.data.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // loadTipologieSchedeValutazione() {
        //     let me = this;
        //     UtilityMixin.methods.loadDataResources(me.pathResource + "/tipologie", { idAccettazione: me.idAccettazione }, me.resultResponseTipologieSchede, me.resultErrorTipologieSchede);
        // },
        // resultResponseTipologieSchede(response) {
        //     let me = this;
        //     response.data.data.forEach((element) => {
        //         me.tipologiaSchedaOptions.push({ text: element.tipologia, value: element.tipologia });
        //     });
        // },
        // resultErrorTipologieSchede(error) {
        //     console.log(error);
        // },
        onUpdateTipologieschede(array) {
            console.log(array);
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroPriLista"] = JSON.stringify(me.filtroPriLista);
            me.$refs.cmpProgettoRiabilitativoIndividualeListComponent.init(me.jsonData);
        },
        onReset() {
            let me = this;
            me.filtroPriLista = { stato: null, dataDal: null, dataAl: null };
            sessionStorage["filtroPriLista"] = JSON.stringify(me.filtroPriLista);
            me.$refs.cmpProgettoRiabilitativoIndividualeListComponent.init(me.jsonData);
        },
    },
};
</script>

<style></style>
